// extracted by mini-css-extract-plugin
export default {"widget":"widgetMT_widget__GF201","wrapper":"widgetMT_wrapper__LZblK","message":"widgetMT_message__3iWbS"};